<template>
  <div>
    <DownloadGuideIos></DownloadGuideIos>
    <div class="front-page-body">
      <div class="header-container">
        <div class="search-box-container">
          <SearchBoxIcon itemType="novel"></SearchBoxIcon>
        </div>
        <div class="icon-checkin">
          <CheckInIcon></CheckInIcon>
        </div>
      </div>

      <div v-if="!isLoading">
        <div v-for="item in pageItemList" :key="item.id">
          <div v-if="item.unit_type === 2">
            <BannerList :bannerList="item.item" v-if="item.item && item.item.length > 0"></BannerList>
          </div>

          <div v-if="item.unit_type === 5" class="shortcut-container">
            <ShortCutComponent :dataList="item.item" v-if="item.item && item.item.length > 0"></ShortCutComponent>
          </div>

          <div v-if="item.unit_type === 4">
            <TabList :dataList="item.item" v-if="item.item && item.item.length > 0" :initialActiveTab="activeTab" :config="item.config"></TabList>
          </div>
        </div>
      </div>

      <TabbarComponent></TabbarComponent>
      <div class="empty-div"></div>
    </div>
  </div>
</template>

<script>
  import BannerList from "../../common/BannerList";
  import SearchBoxIcon from "../../common/SearchBoxIcon";
  import TabbarComponent from "../../common/TabbarComponent";
  import BookShelfIcon from "../../common/BookShelfIcon";
  import CheckInIcon from "../../common/CheckInIcon";
  import {defaultAvatarUrl} from "../../../util/const";
  import DownloadGuideIos from "../../common/DownloadGuideIos";
  import TabList from "../../common/TabList";
  import ShortCutComponent from "../../common/ShortCutComponent";

  export default {
    name: "NovelFeedPage",
    components: {
      ShortCutComponent,
      TabList,
      DownloadGuideIos,
      CheckInIcon,
      BookShelfIcon,
      TabbarComponent,
      SearchBoxIcon,
      BannerList,
    },
    data() {
      return {
        avatarUrl: "",
        userInfo: {},
        pageItemList: [],
        activeTab: "",
        isLoading: true,
      }
    },
    mounted() {
      // this.initPage()
      // this.initUserInfo()
    },

    activated() {
      this.initUserInfo()
      this.initPage()
    },
    methods: {
      initPage() {
        this.$store.dispatch("FeedFrontPage").then((data)=> {
          if (data.code === 0) {
            this.pageItemList = data.data
          }
          this.isLoading = false
        }, ()=> {
          this.isLoading = false
        })
        if (this.$route.query.list_type) {
          this.activeTab = this.$route.query.list_type
        }
      },

      initUserInfo() {
        this.$store.dispatch("AccountInfoMine").then((data) => {
          if (data.code === 0) {
            this.userInfo = data.data
            this.avatarUrl = this.userInfo.avatar_url
          } else {
            this.userInfo = {}
            this.avatarUrl = defaultAvatarUrl
          }
        }, () => {
        })
      },

      onChangeTab(name) {
      },

      onClickMine() {
        if (!this.userInfo || !this.userInfo.id) {
          this.$router.push("/login")
        } else {
          this.$router.push("/_tab_mine")
        }
      }
    },
    computed: {}
  }
</script>

<style lang="scss" scoped>
  .front-page-body {
    background: #fafafa;
  }

  .icon-list {
    background: white;
    padding: 12px 20px;
    display: flex;
    align-items: center;
  }

  .content-list {
    background: white;
    margin-top: 5px;
    min-height: 50vh;

    .content-title {
      padding: 8px 13px;
      border-left: solid 3px blue;
    }
  }

  .header-container {
    padding: 12px 12px;
    border-bottom: 1px solid #f2f2f2;
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .search-box-container {
      flex: 1 1 auto;
      padding: 0 12px;
    }
  }

  .user-avatar {
    flex: 0 0 auto;
    width: 35px;
    height: 35px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: white;
    overflow: hidden;

    img {
      height: 100%;
    }
  }

  .banner-list {
    background: white;
    padding: 12px 15px;
  }

  .icon-bookshelf {
    /*border-bottom: solid 2px #fc9153;*/
    border: solid 1px #fc9153;
    padding: 2px;
    font-size: 14px;
    color: #fc9153;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
  }

  .base-info-box {
    padding: 22px 18px;
    background: white;
    margin: 4px 4px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-around;

    .main-info {
      color: #fc9153;
    }

    .emph-info {
      color: red;
      margin-left: 3px;
    }

    .to-cashier {
      display: flex;
    }

    .sub-info {
      padding: 0 5px;
      color: grey;
    }
  }

  .shortcut-container {
    background: white;
    padding: 18px 0;
  }

  .empty-div {
    padding-bottom: 55px;
    background: white;
  }
</style>

